import { hooks, log } from '@atlassian/mpac-utils';
import { getAppliedPromotions } from '../../../../../../services/AppPromotions';
export const useAppliedPromotions = (productName, cloudId, newPromotionRedeemedName) => {
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getAppliedPromotions(productName, cloudId), [newPromotionRedeemedName]);
  if (error) {
    log.error('PromotionsList/hooks', "Failed to retrieve Promotions List", {
      error
    });
  }
  return {
    pending,
    error,
    appliedPromotions: result || []
  };
};